import styled from "styled-components";

interface StyledProps {
  visible?: boolean;
}

interface SidebarContentProps {
  width?: string;
}

export const SidebarContainer = styled.div<StyledProps>`
  min-width: fit-content;
  height: 100vh;
  top: 100px;
  position: fixed;
  z-index: 999;
  float: right;
  right: ${({ visible }) => (visible ? '0' : '-450px')};
  transition: right 0.3s ease-in-out;
  box-shadow: -1px 0 8px -2px #666666;
  opacity: ${({ visible }) => (visible ? '1' : '0')};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  transition: right 0.3s ease-in-out, opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;

  .sidebar-content-wrapper > div {
    position: relative;
    z-index: 2;
    height: calc(100% - 96px);
  }
`;

export const IconContainer = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SidebarContent = styled.div<SidebarContentProps>`
  position: relative;
  width: ${({ width }) => width ?? '450px'};
  height: 100%;
  overflow: hidden;
  background: var(--color-contrast-white);
  white-space: nowrap;
  box-shadow: -1px 0 5px -2px #a09f9f;
`;

export const Overlay = styled.div<StyledProps>`
  position: fixed;
  top: 100px;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  background-color: #ffffff;
  opacity: ${({ visible }) => (visible ? '0.8' : '0')};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
`;
